import type { ReactNode } from 'react'

type AuthShellProps = {
  title: string
  subtitle?: ReactNode
  /** Если задан — в углу карточки кнопка «Назад» (и системный back в AuthFlow). */
  onBack?: () => void
  children: ReactNode
  footer?: ReactNode
}

/**
 * Оболочка экранов входа/регистрации: форма на тёмной карточке-подложке,
 * фон страницы = цвет полей ввода. Бренд и заголовок центрированы.
 */
export const AuthShell = ({ title, subtitle, onBack, children, footer }: AuthShellProps) => (
  <main className="pwa-auth" aria-label="Провизиум">
    <div className="pwa-auth__card">
      {onBack ? (
        <button type="button" className="pwa-auth__back" onClick={onBack}>
          ← Назад
        </button>
      ) : null}

      <div className="pwa-auth__brand">
        <span className="pwa-auth__logo" aria-hidden="true">
          П
        </span>
        <span className="pwa-auth__name">Провизиум</span>
      </div>
      <h1 className="pwa-auth__title">{title}</h1>
      {subtitle ? <p className="pwa-auth__subtitle">{subtitle}</p> : null}

      {children}

      {footer ? <div className="pwa-auth__foot">{footer}</div> : null}
    </div>
  </main>
)
